const OrderMilstonesCollection = [
    {
        "MilstonePk": "",
        "MilstoneFk": "",
        "MilstoneDescription": "Order Confirmed",
        "MilstoneActualDate": "",
        "MilstoneEstimatedDate": ""
    },
    {
        "MilstonePk": "",
        "MilstoneFk": "",
        "MilstoneDescription": "Ex Factory",
        "MilstoneActualDate": "",
        "MilstoneEstimatedDate": ""
    },
    // {
    //     "MilstonePk": "",
    //     "MilstoneFk": "",
    //     "MilstoneDescription": "Pickup from Origin Factory",
    //     "MilstoneActualDate": "",
    //     "MilstoneEstimatedDate": ""
    // }
]



export default OrderMilstonesCollection